import React, {useRef, useState} from 'react'
import emailjs from '@emailjs/browser';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from "styled-components";


export default function Mailer() {


    const [formData, setFormData] = useState({
        name: "",
        user_email: "",
        message: ""
    })


    const handleChange = (e) => {
        const {name, value} = e.target
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }))
    }

    const sendEmail = (e) => {
        e.preventDefault();
        console.log(formData.user_email.trim().length,formData.name.length,formData.message.trim().length)
        if (formData.name.trim().length && formData.user_email.trim().length > 5 && formData.message.trim().length >= 3) {
            emailjs.sendForm('service_y9dfxht', 'template_vj272op', e.target, 'dP9a-JSeV2CXkDsO5')
                .then((result) => {
                    setFormData({
                        name: "",
                        user_email: "",
                        message: "",
                    })

                    toast.success('😎 Message envoyé avec succès !', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }, (error) => {
                    console.log(error);
                });
        } else {

            toast.error('Les champs sont imcomplets', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }


    return (

        <Formulaire onSubmit={sendEmail}>
            <ToastContainer/>
            <div className="half">
                <div className="item">
                    <label>Nom</label>
                    <input type="text" name='name' value={formData.name} onChange={handleChange} id="nom"/>
                </div>
                <div className="item">
                    <label>Email</label>
                    <input type="email" name='user_email' value={formData.user_email} onChange={handleChange}
                           id="email"/>
                </div>
            </div>
                <div className="full">
                    <label>Message</label>
                    <textarea name="message" value={formData.message} onChange={handleChange} id="message"></textarea>
                </div>

            <div className="action">
                <input type="submit" value='envoyer'/>
            </div>

        </Formulaire>
    )
}

const Formulaire = styled.form`
  width: 640px;
  margin: 50px auto;
  max-width: 97%;
  border-radius: 4px;
  padding: 55px 30px;
  overflow: hidden;


  //position: relative;
  //bottom: 50px;
  .half {
    display: flex;
    justify-content: space-between;
  }

  .half .item {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    width: 48%;
  }

  label {
    display: block;
    font-size: 22px;
    //letter-spacing: 1.5px;
  }

  .item input {
    border-radius: 4px;
    outline: 0;
    padding: 16px;
    width: 100%;
    height: 44px;
    border: 1px solid black;
  }

  .full {
    margin-bottom: 24px;

  }

  .full textarea {
    background: transparent;
    border-radius: 4px;
    outline: 0;
    padding: 12px 16px;
    height: 200px;
    font-size: 17px;
    width: 100%;
  }

  .action {
    margin-bottom: 32px;
  }

  .action input {
    background: transparent;
    border-radius: 4px;
    cursor: pointer;
    font-size: 22px;
    font-weight: 600;
    height: 44px;
    letter-spacing: 2px;
    outline: 0;
    padding: 0 20px 0 22px;
    margin-right: 10px;
  }

  .action input[type="submit"] {
    color: black;
  }

  .half .item input:focus, .full textarea:focus, .action input[type="reset"]:hover {
    background: rgba(255, 255, 255, 0.075);
  }

  @media (max-width: 480px) {
    .half {
      display: flex;
      flex-direction: column;
    }

    .half .item {
      width: 100%;
    }
  }

`
